import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { User } from '../_models';
import { Router } from '@angular/router';
import { RoleStateService } from './role-state.service';
import { UtilitiesService } from './shared/utilities.service';
@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(private http: HttpClient, private router: Router, private roleStateService: RoleStateService,
    private utilitiesService: UtilitiesService) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser') || '{}'));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  login(data: any) {
    return this.http.post<any>(`${environment.apiUrl}/api/authenticate`, { 'username': data.username, 'password': data.password, 'clientId': data.clientId })
      .pipe(map(user => {
        // login successful if there's a jwt token in the response
        if (user && user.id_token) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem('currentUser', JSON.stringify(user));
          this.currentUserSubject.next(user);
        }

        return user;
      }));

  }

  logout() {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('userInfo');
    this.roleStateService.clear();
    this.utilitiesService.resetUserSession();
    localStorage.removeItem('id');
    localStorage.removeItem('displayName');
    localStorage.removeItem('empId');
    localStorage.removeItem('userCode');
    localStorage.removeItem('odooUserId');
    this.currentUserSubject.next(null!);
    this.router.navigate(['login']);
    this.http.post<any>(`${environment.apiUrl}/api/logout`, {}).subscribe();
  }

  isAuthenticated(): boolean {
    const currentUser = this.currentUserSubject.value;
    return currentUser && currentUser.id_token ? true : false;
  }


  userAccessRights(id: string) {
    return this.http.post<any>(`${environment.apiUrl}/api/Auth/UserAccessRights?AccountId=` + id, {})
      .pipe(map(user => {
        return user;
      }));
  }
  validateResetToken(data: any) {

    const apiUrl = environment.apiUrl + '/api/Auth/ValidateResetToken';
    // const headers = new HttpHeaders({
    //   'Authorization': 'Bearer your-access-token', // Replace with your actual Bearer token
    //   'Content-Type': 'application/json'
    // });
    const obj = {
      resetToken: data
    }
    return this.http.post(apiUrl, obj);
  }
  isemailExist(email: any) {

    const apiUrl = environment.apiUrl + `/api/Auth/IsEmailExist?email=${email}`;
    return this.http.post(apiUrl, '');
  }
  reset_paswword(data: any) {

    const apiUrl = environment.apiUrl + `/api/Auth/reset-password`;
    return this.http.post(apiUrl, data);
  }
  authenticateUser(data: any) {

    const apiUrl = environment.apiUrl + `/api/Auth/AuthenticateUser`;
    const obj = {
      "email": data.email,
      "password": data.password,
    }
    return this.http.post(apiUrl, obj);
  }
  forgot_password(email: any) {

    const apiUrl = environment.apiUrl + `/api/Auth/ForgotPassword`;
    const obj = {
      email: email
    }
    return this.http.post(apiUrl, obj);
  }

  verifyOtp(data: any) {
    return this.http.post<any>(`${environment.apiUrl}/api/verify-otp`, data)
      .pipe(map(res => {
        if (res && res.id_token) {
          localStorage.setItem('currentUser', JSON.stringify(res));
          this.currentUserSubject.next(res);
        }
        return res;
      }));
  }
 request2FAReset(data: any) {
  return this.http.post<any>(
    `${environment.apiUrl}/api/2fa/reset/request?clientId=${data.clientId}&email=${encodeURIComponent(data.email)}`,
    {
      username: data.email,
      clientId: data.clientId
    }
  );
}
verify2FAResetOtp(data: any) {
  return this.http.post<any>(
    `${environment.apiUrl}/api/verify-2fa-reset-otp?clientId=${data.clientId}&email=${encodeURIComponent(data.username)}&otp=${data.otp}`,
    null
  );
}
}